import { Typography, openModal } from 'enable-ui';
import { useStationStore } from 'stores/station';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { AddButton } from 'modules/dashboard/styles/functional-test';

import { ReactComponent as AddIcon } from 'assets/icons/add.svg';

import { COLOR } from 'constants/color';

import { AddStationModal } from '../components/AddStationModal';
import { StationCard } from '../components/StationCard';
import { useStationsController } from '../core/controllers/stations';

const StationsPage = () => {
  const stations = useStationStore().state.stations;
  const onEditStation = useStationsController().onEditStation;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridGap: 16 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          border: `1px dashed ${COLOR.purpel['purpel-6']}`,
          borderRadius: 12,
          padding: '0 24px 0 22px',
          minWidth: 200,
          height: 176,
          justifyContent: 'center',
          color: COLOR.purpel['purpel-6'],
          cursor: 'pointer',
        }}
        onClick={() => openModal(MODAL_KEY.ADD_STATION)}
      >
        <AddButton style={{ marginTop: 0, width: 'auto' }}>
          <AddIcon style={{ width: 20, height: 20 }} />
          <Typography weight={600} style={{ fontSize: 18, lineHeight: '26px' }}>
            Add
          </Typography>
        </AddButton>
      </div>

      {stations?.map((station, index) => (
        <StationCard
          key={index}
          station={station}
          onClick={() => {
            onEditStation(station?.id ?? '');
          }}
        />
      ))}

      <AddStationModal />
    </div>
  );
};

export default StationsPage;
